export default __webpack_public_path__ + "static/media/IconAddressHome.51a94568.svg";